'use client';

import { css } from '@flipster/styled-system/css';
import { flex, grid } from '@flipster/styled-system/patterns';

import { SegmentPage } from '../misc/segment/segment-page';
import { useIsWebview } from '../shared/webview';
import CrossMarginVersusIsolatedMargin from './_sections/cross-margin-versus-isolated-margin';
import MultiAssetsCollateral from './_sections/multi-assets-collateral';
import SupportedAssets from './_sections/supported-assets';
import WebviewFooter from './_sections/webview-footer';

const CollateralOverviewPage = () => {
  const isWebview = useIsWebview();

  return (
    <>
      <SegmentPage name='collateral_overview_page_view' />
      <main
        className={css({
          position: 'relative',
          minH: 'minHeightWithoutNavigationAndFooter',
          pt: { base: 16, smallDesktop: 80 },
          tablet: {
            maxWidth: 'desktopMaxWidth',
            mx: 'auto',
          },
        })}
      >
        <div
          className={flex({
            direction: 'column',
            gap: 48,
            px: { base: 16, smallDesktop: 0 },
            pb: { base: 186, smallDesktop: 150 },
          })}
        >
          <div
            className={grid({
              gap: { base: 48, tablet: 20 },
              columns: { base: 1, tablet: 2 },
            })}
          >
            <CrossMarginVersusIsolatedMargin />
            <MultiAssetsCollateral />
          </div>
          <SupportedAssets />
        </div>
        {isWebview && <WebviewFooter />}
      </main>
    </>
  );
};

export default CollateralOverviewPage;
